export default __webpack_public_path__ + "static/media/5.0e9f63b0.gif";